import gql from 'graphql-tag'

export const ProfileFragmentGQL = gql`
  fragment ProfileFragment on MerchantProfile {
    draft
    active
    auditPassed
    bankBik
    bankCheckingAccount
    bankCorrAccount
    bankName
    cashBackPeriod
    checkScanLimit
    cityList {
      id
      country {
        id
        name
        code
        currency
      }
      name
      nameNational
      lat
      lng
      timezone
    }
    contactFinances
    contactMarketingPrAd
    contactFinances
    contactMarketingPrAd
    contactTechnical
    contractList {
      activeFrom
      activeTo
      balance
      currency
      externalGuid
      id
      number
      partnerEntity {
        externalGuid
        id
        inn
        isActive
        name
      }
    }
    countDaysBeforeChangeCashBackPeriod
    countryList {
      id
      name
      code
      currency
    }
    currency
    documentList {
      id
      fileName
      documentCode
      file
      source
      downloadUrl
    }
    email
    gold
    goldShopLogin
    id
    isNeedToConfirmQr
    isQrScan
    managerComment
    marketingDescription
    marketingName
    merchantId
    numberOfRetailCashbox
    offline
    online
    orderCategory {
      id
      translationList {
        id
        locale
        name
        description
        condition
      }
    }
    prepayment
    programStatus
    recruitedUser
    reqAccountantGeneral
    reqActualAddress
    reqBsn
    reqBusinessName
    reqClassificationMX
    reqClassification
    reqCompanyDirector
    reqCompanyRegistrationDate
    reqContactPhone
    reqCountry {
      id
      name
      code
      currency
    }
    reqCscp
    reqEdrpou
    reqIik
    reqInn
    reqKpp
    reqLegalAddress
    reqLegalName
    reqMfo
    reqOgrn
    reqOkved
    reqPostAddress
    reqTechnicalServicePhone
    reqTin
    reqIpn
    reqUpn
    rewardPercent
    rewardAmount
    ruleFns
    opportunityGoldShop
    recruitedLoginApprove
    shopList {
      id
      contactList {
        id
        name
        type
        contact
      }
      workingHoursList {
        id
        weekDay
        workStartMin
        workEndMin
        date
      }
      name
      address
      lat
      lng
    }
    slug
    status
    website
    recruitedUser
    reqAccountantGeneral
  }
`
